import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-limit-error-dialog',
    templateUrl: './limit-error-dialog.html',
})
export class LimitErrorDialogComponent {

    public isIT: boolean = true;

    constructor(
        public loc: LocalizationService,
        public dialogRef: MatDialogRef<LimitErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any)
        {
          this.isIT = this.loc.currLang() == "IT";
        }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/limit-error-dialog/limit-error-dialog.ts